// @flow

import React, { Component } from 'react';

import HeaderDefault from 'app/viewport/components/Header/HeaderDefault';
import Styles from 'app/viewport/components/Header/HeaderBlock.scss';
import shouldComponentUpdate from 'app/perf-utils/components/shouldComponentUpdate';

import type { HeaderProps } from 'app/viewport/components/Header/HeaderDefault';

const getBodyElement = () => {
  // `document` does not exist in SSR, so avoid interacting with this
  // API if this is performed on the server.
  if (!document) {
    return null;
  }

  return document.querySelector('body');
};

type State = {
  isMenuVisible: boolean,
  isServiceSearchVisible: boolean,
  megaMenuVisible?: string,
};

class StatefulHeader extends Component<HeaderProps, State> {
  state = {
    isMenuVisible: false,
    isServiceSearchVisible: false,
  };

  shouldComponentUpdate = shouldComponentUpdate.deepCheckStateAndProps;

  UNSAFE_componentWillMount() {
    this.props.onMount();
  }

  onHideMenu = () => {
    const $body = getBodyElement();

    if ($body) {
      $body.classList.remove(Styles.headerMobileMenuOpenClass);
    }

    this.setState({
      isMenuVisible: false,
    });
  };

  onRevealMenu = () => {
    const $body = getBodyElement();

    if ($body) {
      $body.classList.add(Styles.headerMobileMenuOpenClass);
    }

    this.setState({
      isMenuVisible: true,
    });
  };

  onToggleMenu = () =>
    !this.state.isMenuVisible ? this.onRevealMenu() : this.onHideMenu();

  onOpenServiceSearch = () => {
    this.setState({
      isServiceSearchVisible: true,
    });
  };

  onCloseServiceSearch = () => {
    this.setState({
      isServiceSearchVisible: false,
    });
  };

  render() {
    const { CustomComponent = HeaderDefault } = this.props;

    return (
      <CustomComponent
        {...this.props}
        {...this.state}
        onCloseServiceSearch={this.onCloseServiceSearch}
        onHideMenu={this.onHideMenu}
        onOpenServiceSearch={this.onOpenServiceSearch}
        onRevealMenu={this.onRevealMenu}
        onToggleMenu={this.onToggleMenu}
      />
    );
  }
}

export default StatefulHeader;
